<template>
  <Frontendlayout>
    <section class="hero_in hotels hero_single version_2">
      <div class="wrapper">
        <div class="container">
          <h3>Search Near by Offers</h3>
          <!-- <p>Expolore top rated tours, hotels and restaurants around the world</p> -->
          <form id="filter-type-1">
            <div class="row no-gutters custom-search-input-2">
              <div class="col-lg-2">
                <div class="form-group">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="pincode..."
                    v-model="search.pincode"
                  />
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Location..."
                    v-model="search.location"
                  />
                  <i class="icon_pin_alt"></i>
                </div>
              </div>
              <div class="col-lg-4">
                <select
                  v-model="search.categories"
                  multiple="multiple"
                  data-placeholder="Choose Categories"
                  data-allow-clear="1"
                  data-select2-id="4"
                  tabindex="-1"
                  class="select2"
                  aria-hidden="true"
                >
                  <option
                    v-for="(cat, index) in categories"
                    :value="cat.id"
                    :key="index"
                  >
                    {{ cat.category }}
                  </option>
                </select>
              </div>
              <div class="col-lg-3">
                <input
                  type="button"
                  class="btn_search"
                  value="Search"
                  @click="loadFilter"
                />
              </div>
            </div>
            <!-- /row -->
          </form>
        </div>
      </div>
    </section>
    <!-- /hero_single -->
    <div class="filters_listing sticky_horizontal">
      <div class="container">
        <ul class="clearfix">
          <li>
            <div class="switch-field">
              <input type="radio" id="all" name="listing_filter" value="all" />
              <label for="all">All</label>
              <input
                type="radio"
                id="popular"
                name="listing_filter"
                value="popular"
              />
              <label for="popular">Popular</label>
              <input
                type="radio"
                id="latest"
                name="listing_filter"
                value="latest"
              />
              <label for="latest">Latest</label>
            </div>
          </li>
          <li>
            <div class="layout_view">
              <router-link to="/filter-list-1-gridview"
                ><i class="icon-th"></i
              ></router-link>
              <!--a href="hotels-grid-isotope.html"><i class="icon-th"></i></a-->
              <a href="#0" class="active"><i class="icon-th-list"></i></a>
            </div>
          </li>
          <li>
            <a
              class="btn_map"
              data-toggle="collapse"
              href="#collapseMap"
              aria-expanded="false"
              aria-controls="collapseMap"
              data-text-swap="Hide map"
              data-text-original="View on map"
              >View on map</a
            >
          </li>
        </ul>
      </div>
      <!-- /container -->
    </div>
    <!-- /filters -->
    <div class="collapse" id="collapseMap">
      <div id="map" class="map"></div>
    </div>
    <!-- End Map -->
    <div class="container margin_60_35">
      <div class="col-lg-12">
        <div class="row no-gutters custom-search-input-2 inner">
          <div class="col-lg-4">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                placeholder="What are you looking for..."
              />
              <i class="icon_search"></i>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <input class="form-control" type="text" placeholder="Where" />
              <i class="icon_pin_alt"></i>
            </div>
          </div>
          <div class="col-lg-3">
            <select class="wide">
              <option>All Categories</option>
              <option>Paris Center</option>
              <option>La Defanse</option>
              <option>Latin Quarter</option>
            </select>
          </div>
          <div class="col-lg-2">
            <input type="submit" class="btn_search" value="Search" />
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /custom-search-input-2 -->
      <div class="isotope-wrapper">
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-md-6 isotope-item popular">
            <div class="box_grid">
              <figure>
                <a href="#0" class="wish_bt"></a>
                <a href="hotel-detail.html"
                  ><img
                    src="img/hotel_1.jpg"
                    class="img-fluid"
                    alt=""
                    width="800"
                    height="533"
                  />
                  <div class="read_more"><span>Read more</span></div></a
                >
                <small>Paris Centre</small>
              </figure>
              <div class="wrapper">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3><a href="hotel-detail.html">Park Hyatt Hotel</a></h3>
                <p>
                  Id placerat tacimates definitionem sea, prima quidam vim no.
                  Duo nobis persecuti cu.
                </p>
                <span class="price">From <strong>$54</strong> /per person</span>
              </div>
              <ul>
                <li><i class="ti-eye"></i> 164 views</li>
                <li>
                  <div class="score">
                    <span>Superb<em>350 Reviews</em></span
                    ><strong>8.9</strong>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /box_grid -->
          <div class="col-xl-4 col-lg-6 col-md-6 isotope-item latest">
            <div class="box_grid">
              <figure>
                <a href="#0" class="wish_bt"></a>
                <a href="hotel-detail.html"
                  ><img
                    src="img/hotel_2.jpg"
                    class="img-fluid"
                    alt=""
                    width="800"
                    height="533"
                  />
                  <div class="read_more"><span>Read more</span></div></a
                >
                <small>Paris Centre</small>
              </figure>
              <div class="wrapper">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3><a href="hotel-detail.html">Mariott Hotel</a></h3>
                <p>
                  Id placerat tacimates definitionem sea, prima quidam vim no.
                  Duo nobis persecuti cu.
                </p>
                <span class="price"
                  >From <strong>$124</strong> /per person</span
                >
              </div>
              <ul>
                <li><i class="ti-eye"></i> 164 views</li>
                <li>
                  <div class="score">
                    <span>Good<em>350 Reviews</em></span
                    ><strong>7.0</strong>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /box_grid -->
          <div class="col-xl-4 col-lg-6 col-md-6 isotope-item popular">
            <div class="box_grid">
              <figure>
                <a href="#0" class="wish_bt"></a>
                <a href="hotel-detail.html"
                  ><img
                    src="img/hotel_3.jpg"
                    class="img-fluid"
                    alt=""
                    width="800"
                    height="533"
                  />
                  <div class="read_more"><span>Read more</span></div></a
                >
                <small>Paris Centre</small>
              </figure>
              <div class="wrapper">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3><a href="hotel-detail.html">Lumiere Hotel</a></h3>
                <p>
                  Id placerat tacimates definitionem sea, prima quidam vim no.
                  Duo nobis persecuti cu.
                </p>
                <span class="price">From <strong>$25</strong> /per person</span>
              </div>
              <ul>
                <li><i class="ti-eye"></i> 164 views</li>
                <li>
                  <div class="score">
                    <span>Good<em>350 Reviews</em></span
                    ><strong>7.0</strong>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /box_grid -->
          <div class="col-xl-4 col-lg-6 col-md-6 isotope-item latest">
            <div class="box_grid">
              <figure>
                <a href="#0" class="wish_bt"></a>
                <a href="hotel-detail.html"
                  ><img
                    src="img/hotel_4.jpg"
                    class="img-fluid"
                    alt=""
                    width="800"
                    height="533"
                  />
                  <div class="read_more"><span>Read more</span></div></a
                >
                <small>Paris Centre</small>
              </figure>
              <div class="wrapper">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3><a href="hotel-detail.html">Concorde Hotel</a></h3>
                <p>
                  Id placerat tacimates definitionem sea, prima quidam vim no.
                  Duo nobis persecuti cu.
                </p>
                <span class="price">From <strong>$45</strong> /per person</span>
              </div>
              <ul>
                <li><i class="ti-eye"></i> 164 views</li>
                <li>
                  <div class="score">
                    <span>Superb<em>350 Reviews</em></span
                    ><strong>9.0</strong>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /box_grid -->
          <div class="col-xl-4 col-lg-6 col-md-6 isotope-item popular">
            <div class="box_grid">
              <figure>
                <a href="#0" class="wish_bt"></a>
                <a href="hotel-detail.html"
                  ><img
                    src="img/hotel_5.jpg"
                    class="img-fluid"
                    alt=""
                    width="800"
                    height="533"
                  />
                  <div class="read_more"><span>Read more</span></div></a
                >
                <small>Paris Centre</small>
              </figure>
              <div class="wrapper">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3><a href="hotel-detail.html">Louvre Hotel</a></h3>
                <p>
                  Id placerat tacimates definitionem sea, prima quidam vim no.
                  Duo nobis persecuti cu.
                </p>
                <span class="price">From <strong>$65</strong> /per person</span>
              </div>
              <ul>
                <li><i class="ti-eye"></i> 164 views</li>
                <li>
                  <div class="score">
                    <span>Good<em>350 Reviews</em></span
                    ><strong>7.5</strong>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /box_grid -->
          <div class="col-xl-4 col-lg-6 col-md-6 isotope-item latest">
            <div class="box_grid">
              <figure>
                <a href="#0" class="wish_bt"></a>
                <a href="hotel-detail.html"
                  ><img
                    src="img/hotel_6.jpg"
                    class="img-fluid"
                    alt=""
                    width="800"
                    height="533"
                  />
                  <div class="read_more"><span>Read more</span></div></a
                >
                <small>Paris Centre</small>
              </figure>
              <div class="wrapper">
                <div class="cat_star">
                  <i class="icon_star"></i><i class="icon_star"></i
                  ><i class="icon_star"></i><i class="icon_star"></i>
                </div>
                <h3><a href="hotel-detail.html">Concorde Hotel</a></h3>
                <p>
                  Id placerat tacimates definitionem sea, prima quidam vim no.
                  Duo nobis persecuti cu.
                </p>
                <span class="price">From <strong>$95</strong> /per person</span>
              </div>
              <ul>
                <li><i class="ti-eye"></i> 164 views</li>
                <li>
                  <div class="score">
                    <span>Good<em>350 Reviews</em></span
                    ><strong>7.8</strong>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /box_grid -->
        </div>
        <!-- /row -->
      </div>
      <!-- /isotope-wrapper -->

      <p class="text-center">
        <a href="#0" class="btn_1 rounded add_top_30">Load more</a>
      </p>
    </div>
    <!-- /container -->
  </Frontendlayout>
</template>

<script>
import Frontendlayout from "../layouts/Frontendlayout.vue";
import { EventBus } from "@/EventBus";
export default {
  data() {
    return {
      created: {},
      name: "Filter",
      divId: "home",
      bodyId: "",
      categories: [],
      search: {
        pincode: "401203",
        location: "Mumbai, Maharashtra",
        categories: [1, 5, 6],
      },
    };
  },
  beforeMount() {
    this.getParentservices();
    if (this.search.categories.length > 0) {
      this.setLeftFilter();
    }
  },
  mounted() {
    EventBus.$on("route-data", (data) => {
      this.search = data;
    });
  },
  components: { Frontendlayout },
  methods: {
    setLeftFilter() {
      alert(this.search.categories);
    },
    getParentservices() {
      // alert(token);

      this.$api
        .get("categories/parent_services")
        .then((res) => {
          this.categories = res.data.data;
          console.log(this.categories);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    loadFilter() {},
  },
};
</script>


<style  scoped>
/*@import "../../public/frontend/css/custom.css";*/
</style>